import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Headphones, CreditCard, ArrowRight } from 'lucide-react';
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: 0.2 + i * 0.12,
      ease: 'easeOut'
    }
  })
};
export function G7CloudPitch() {
  return <motion.section initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.5,
    ease: 'easeOut'
  }} className="w-full bg-white rounded-xl border border-slate-200 shadow-sm px-6 sm:px-10 py-10 sm:py-14 relative overflow-hidden" aria-labelledby="pitch-heading" data-id="element-46">
      {/* Subtle top accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-g7-navy to-g7-orange opacity-20" data-id="element-47" />

      {/* Label */}
      <p className="text-xs font-bold uppercase tracking-wider text-g7-orange mb-3" data-id="element-48">
        Powered by G7Cloud Infrastructure
      </p>

      {/* Heading */}
      <h2 id="pitch-heading" className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3" data-id="element-49">
        Looking for hosting you can count on?
      </h2>

      {/* Subtext */}
      <p className="text-base text-slate-600 max-w-2xl leading-relaxed mb-10" data-id="element-50">
        G7Cloud provides enterprise-grade web hosting infrastructure with
        guaranteed uptime, 24/7 support, and transparent billing.
      </p>

      {/* Feature cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5 mb-10" data-id="element-51">
        <motion.div custom={0} initial="hidden" animate="visible" variants={cardVariants} className="rounded-lg border border-slate-100 bg-slate-50 p-5 hover:border-orange-100 transition-colors duration-300" data-id="element-52">
          <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-orange-50 mb-4" data-id="element-53">
            <Shield className="h-5 w-5 text-g7-orange" aria-hidden="true" data-id="element-54" />
          </div>
          <h3 className="text-sm font-bold text-slate-900 mb-1" data-id="element-55">
            99.9% Uptime Guarantee
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed" data-id="element-56">
            Enterprise-grade infrastructure you can rely on
          </p>
        </motion.div>

        <motion.div custom={1} initial="hidden" animate="visible" variants={cardVariants} className="rounded-lg border border-slate-100 bg-slate-50 p-5 hover:border-orange-100 transition-colors duration-300" data-id="element-57">
          <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-orange-50 mb-4" data-id="element-58">
            <Headphones className="h-5 w-5 text-g7-orange" aria-hidden="true" data-id="element-59" />
          </div>
          <h3 className="text-sm font-bold text-slate-900 mb-1" data-id="element-60">
            24/7 Expert Support
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed" data-id="element-61">
            Real humans ready to help, any time of day
          </p>
        </motion.div>

        <motion.div custom={2} initial="hidden" animate="visible" variants={cardVariants} className="rounded-lg border border-slate-100 bg-slate-50 p-5 hover:border-orange-100 transition-colors duration-300" data-id="element-62">
          <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-orange-50 mb-4" data-id="element-63">
            <CreditCard className="h-5 w-5 text-g7-orange" aria-hidden="true" data-id="element-64" />
          </div>
          <h3 className="text-sm font-bold text-slate-900 mb-1" data-id="element-65">
            Transparent Billing
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed" data-id="element-66">
            No surprises. Clear pricing, honest service.
          </p>
        </motion.div>
      </div>

      {/* CTAs */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-67">
        <a href="https://g7cloud.com/wordpress-hosting/" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-g7-orange text-white text-sm font-bold hover:bg-orange-600 transition-colors shadow-sm shadow-orange-200" data-id="element-68">
          Explore G7Cloud Hosting
        </a>
        <a href="https://g7cloud.com/contact/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-g7-navy hover:text-g7-orange transition-colors" data-id="element-69">
          Contact our sales team
          <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" data-id="element-70" />
        </a>
      </div>
    </motion.section>;
}